import { render, staticRenderFns } from "./LabElementForm.vue?vue&type=template&id=8b907b9a"
import script from "./LabElementForm.vue?vue&type=script&lang=js"
export * from "./LabElementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b907b9a')) {
      api.createRecord('8b907b9a', component.options)
    } else {
      api.reload('8b907b9a', component.options)
    }
    module.hot.accept("./LabElementForm.vue?vue&type=template&id=8b907b9a", function () {
      api.rerender('8b907b9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/labElement/LabElementForm.vue"
export default component.exports